<template>
  <div>
    <b-row>
      <b-col sm="3">
        <label>Tipo:</label>
      </b-col>
      <b-col sm="6">
        <label>Producto:</label>
      </b-col>
      <b-col sm="2">
        <label>Cantidad:</label>
      </b-col>
    </b-row>
    <b-row v-for="(row,index) in list" v-bind:key="index">
      <b-col sm="3">
        <b-form-group>
          <b-form-select
            @change="getProductsByType(index,row.type)"
            :options="productTypes"
            v-model="row.type"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group>
          <b-form-select
            required
            @change="selectProduct(index)"
            :options="row.options"
            v-model="row.product"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group>
          <b-form-input
            @change="getTotalPrice(index)" 
            v-on:keyup="getTotalPrice(index)"
            type="number"
            min="1"
            step="any"
            v-model.number="row.quantity"
            required
          ></b-form-input> 
        </b-form-group>
      </b-col>
      <b-col sm="1">
        <b-form-group>
          <b-button
            variant="danger"
            size="sm"
            style="margin:3px;"
            @click="removeProduct(index)"
            v-if="rows.length>1"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4">
        <b-button variant="light" class="float-left" @click="addRow()">
          <i class="fas fa-plus-circle"></i> Agregar producto
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "listaProductos",
  props: {
    rows: Array,
    productTypes: Array,
    AllProductsOptions: Array,
    products: Array,
    getTotalPrice: Function,
    getTotal: Function,
    verifyQuantity: Function,
    selectProduct: Function
  },
  data: function() {
    return {
      list: this.rows,
      pTypes: this.productTypes,
      alloptions: this.AllProductsOptions
    };
  },
  watch:{
    rows:function(newValue,oldValue){
      this.list = newValue;
    }
  },
  methods: {
    getProductsByType(index, type) {
      if (type != null) {
        this.list[index].product = null;
        this.list[index].quantity = 1;
        this.list[index].options.splice(1);
        const newOptions = this.products.filter(p => p.type._id == type);
        newOptions.map(p => {
          if (p.brand != null && p.brand.name) {
            this.list[index].options.push({
              text: `${p.productName} Marca: ${p.brand.name}`,
              value: this.products.indexOf(p)
            });
          } else {
            this.list[index].options.push({
              text: `${p.productName} Marca: N/A`,
              value: this.products.indexOf(p)
            });
          }
        });
        this.getTotalPrice(index);
      } else {
        this.list[index].product = null;
        this.list[index].quantity = 1;
        this.list[index].options = [];
        this.list[index].options = [...this.alloptions];
        this.getTotalPrice(index);
      }
    },
    selectProduct(index) {
      this.list[index].quantity = 1;
      this.getTotalPrice(index);
    },
    addRow() {
      this.list.push({
        type: null,
        product: null,
        quantity: 1,
        products: [],
        options: [],
        compatibility: null,
        price: 0,
        priceWDisc: 0,
        disc: 0,
        discPesos: 0,
        showDisc: false
      });
      this.list[this.list.length - 1].options = [...this.alloptions];
    },
    removeProduct(index) {
      this.list.splice(index, 1);
      this.getTotal();
    }
  }
};
</script>